var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PBSLM_TITLE } from "./constants";
import Utils from "../utils/utils";
var BaseNode = /** @class */ (function () {
    function BaseNode(id, title, type, parents, children) {
        if (type === void 0) { type = ""; }
        if (parents === void 0) { parents = []; }
        if (children === void 0) { children = []; }
        this.id = id;
        this.title = title;
        this.type = type;
        this.parents = parents;
        this.children = children;
    }
    BaseNode.fromObject = function (obj, parents) {
        if (parents === void 0) { parents = []; }
        var id = obj.id, title = obj.title, _a = obj.children, children = _a === void 0 ? [] : _a, type = obj.type;
        var node = new BaseNode(id, title, type, parents);
        if (children.length) {
            var childParents_1 = parents.concat(node);
            node.children = children.map(function (child) {
                return BaseNode.fromObject(child, childParents_1);
            });
        }
        return node;
    };
    return BaseNode;
}());
export { BaseNode };
var CHNode = /** @class */ (function (_super) {
    __extends(CHNode, _super);
    function CHNode(id, title, resultsCount, banner, description, posterImage, posterImageAltText, slug, parents, children, metaTitle, type) {
        if (banner === void 0) { banner = ""; }
        if (description === void 0) { description = ""; }
        if (posterImage === void 0) { posterImage = ""; }
        if (posterImageAltText === void 0) { posterImageAltText = ""; }
        if (slug === void 0) { slug = ""; }
        if (parents === void 0) { parents = []; }
        if (children === void 0) { children = []; }
        if (metaTitle === void 0) { metaTitle = ""; }
        if (type === void 0) { type = "subject"; }
        var _this = _super.call(this, id, title, type, parents) || this;
        _this.id = id;
        _this.title = title;
        _this.resultsCount = resultsCount;
        _this.banner = banner;
        _this.description = description;
        _this.posterImage = posterImage;
        _this.posterImageAltText = posterImageAltText;
        _this.slug = slug;
        _this.parents = parents;
        _this.children = children;
        _this.metaTitle = metaTitle;
        _this.type = type;
        _this.posterImage = Utils.escapePosterImage(_this.posterImage);
        return _this;
    }
    CHNode.empty = function () {
        return new CHNode(0, "", 0);
    };
    CHNode.fromObject = function (obj, parents) {
        if (parents === void 0) { parents = []; }
        var id = obj.id, title = obj.title, results_count = obj.results_count, _a = obj.banner, banner = _a === void 0 ? "" : _a, _b = obj.description, description = _b === void 0 ? "" : _b, _c = obj.poster_image, poster_image = _c === void 0 ? "" : _c, _d = obj.poster_image_alt_text, poster_image_alt_text = _d === void 0 ? "" : _d, _e = obj.slug, slug = _e === void 0 ? "" : _e, _f = obj.children, children = _f === void 0 ? [] : _f;
        var node = new CHNode(id, title, results_count, banner, description, poster_image, poster_image_alt_text, slug, parents);
        // Optimization. The title is the same
        node.metaTitle = obj.meta_title || title + " | " + PBSLM_TITLE;
        if (!slug && parents.length) {
            // Optimization. The slug should be calculated based on the parent
            var lastParent = parents[parents.length - 1];
            node.slug = "" + this.cleanSlug(lastParent.slug) + this.slugify(node.title) + "/";
        }
        if (children.length) {
            var childParents_2 = parents.concat(node);
            node.children = children.map(function (child) {
                return CHNode.fromObject(child, childParents_2);
            });
        }
        CHNode.addToFlatLists(node);
        return node;
    };
    CHNode.addToFlatLists = function (node) {
        CHNode.nodesByID[node.id] = node;
        CHNode.nodesBySlug[node.slug] = node;
        CHNode.nodesByTitle[node.title.toLowerCase()] = node;
    };
    CHNode.byID = function (id) {
        return CHNode.nodesByID[id];
    };
    CHNode.bySlug = function (slug) {
        return CHNode.nodesBySlug[slug];
    };
    CHNode.byTitle = function (title) {
        return CHNode.nodesByTitle[title];
    };
    CHNode.slugify = function (title) {
        return title
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^-a-z0-9/_]/g, "");
    };
    CHNode.cleanSlug = function (slug) {
        if (!slug.startsWith("/")) {
            slug = "/" + slug;
        }
        if (!slug.endsWith("/")) {
            slug = slug + "/";
        }
        return slug;
    };
    CHNode.getBrowseURLForSlug = function (slug) {
        return "/subjects" + this.cleanSlug(slug);
    };
    CHNode.prototype.getBrowseURL = function () {
        return CHNode.getBrowseURLForSlug(this.slug);
    };
    CHNode.prototype.getDepth = function () {
        var parentsLength = this.parents.length;
        return parentsLength ? parentsLength + 1 : 1;
    };
    CHNode.prototype.getNodeFromLevel = function (level) {
        var parentsLength = this.parents.length;
        if (parentsLength < level) {
            return null;
        }
        if (parentsLength === level) {
            return this;
        }
        return this.parents[level];
    };
    CHNode.prototype.getDiscipline = function () {
        return this.getNodeFromLevel(0);
    };
    CHNode.prototype.getSubject = function () {
        return this.getNodeFromLevel(1);
    };
    CHNode.prototype.getTopic = function () {
        return this.getNodeFromLevel(2);
    };
    CHNode.prototype.getTopParents = function (limit, includeSelf) {
        if (limit === void 0) { limit = 2; }
        if (includeSelf === void 0) { includeSelf = true; }
        var availableNodes = this.parents.slice();
        if (includeSelf) {
            availableNodes.push(this);
        }
        return availableNodes.slice(0, limit);
    };
    CHNode.prototype.isLoaded = function () {
        return !!(this.slug && this.title);
    };
    CHNode.nodesByID = {};
    CHNode.nodesBySlug = {};
    CHNode.nodesByTitle = {};
    return CHNode;
}(BaseNode));
export { CHNode };
